import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";
import { write, writeFile, utils } from "xlsx";
import { exportExcelState } from "../../actions/studensts";

export default function Deliver() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(
      () => dispatch(getType("deliver", state, search)),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const handleExport = async () => {
    try {
      const { data } = await exportExcelState("deliver_onsite");
      const stateFilter = data.data;
      const fields = [
        "id",
        "passport_number",
        "full_name",
        "test_center_name",
        "phone",
        "gender",
        "category",
        "email",
        "act1_copy_number",
        "act2_copy_number",
        "submit_date",
        "request_edit_user",
        "request_edit",
        "moe_validation_user",
        "moe_pending_date",
        "moe_pending_user",
        "total_main",
        "another_total_main",
        "amount_outside",
      ];
      const filteredData = stateFilter.map((item) => {
        const filteredItem = {};
        fields.forEach((field) => {
          filteredItem[field] = item[field];
        });
        return filteredItem;
      });
      const workSheet = utils.json_to_sheet(filteredData);
      const workBook = utils.book_new();
      utils.book_append_sheet(workBook, workSheet, "deliver_onsite");
      write(workBook, { bookType: "xlsx", type: "buffer" });
      write(workBook, { bookType: "xlsx", type: "binary" });
      writeFile(workBook, "deliver_onsite.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <div className="flex items-center justify-between px-6 pt-4">
            <h1 className="text-2xl pt-0 pb-5 text-white">
              {studentType === "deliver_onsite"
                ? "Delivery Onsite"
                : studentType === "aramex"
                ? "Aramex"
                : ""}
            </h1>
            {studentType === "deliver_onsite" && (
              <button
                onClick={handleExport}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
              >
                Export to Excel
              </button>
            )}
          </div>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
              flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                setSearch={(val) => {
                  setSearch(val);
                  setHasSearched(true);
                }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "deliver_onsite":
      return "deliver_onsite";
    case "aramex":
      return "aramex";
    default:
      return "deliver_onsite";
  }
}
